export default "__VITE_ASSET__DWeXm_2n__"